import { useEffect } from 'react';
import { getFeaturesDto, getVisualContentRaw } from '../services/restaurantDataService';
import { useItemsStore } from '../store';
import { normalizeVisualContent } from '../utils/normalizeVisualContent';

export const useVisualContent = (
  restaurantId: string | undefined,
  mode: 'LOCAL' | 'DELIVERY',
): void => {
  const setFeaturesStore = useItemsStore((s) => s.setFeatures);
  const setCarouselContentStore = useItemsStore((s) => s.setCarouselContent);

  useEffect(() => {
    if (!restaurantId) return;

    let active = true;
    let currentController: AbortController | null = null;

    const loadContent = () => {
      currentController?.abort();
      currentController = new AbortController();
      const { signal } = currentController;

      Promise.all([
        getFeaturesDto(restaurantId, mode, '1', signal),
        getVisualContentRaw(restaurantId, mode, signal),
      ])
        .then(([features, visualRaw]) => {
          if (!active || signal.aborted) return;
          setFeaturesStore(Array.isArray(features) ? features : []);
          setCarouselContentStore(normalizeVisualContent(visualRaw, restaurantId));
        })
        .catch(() => {
          if (!active || signal.aborted) return;
          setFeaturesStore([]);
          setCarouselContentStore([]);
        });
    };

    loadContent();
    window.addEventListener('focus', loadContent);

    return () => {
      active = false;
      currentController?.abort();
      window.removeEventListener('focus', loadContent);
    };
  }, [restaurantId, mode, setFeaturesStore, setCarouselContentStore]);
};
